import { defineStore } from 'pinia'
import { useFetch } from '@vueuse/core'

export const useEventsStore = defineStore('events', {
  state: () => {
    return {
      events: undefined,
      isCurriculum: false
    }
  },
  actions: {
    async setCurriculum (isCurriculum) {
      this.isCurriculum = isCurriculum
    },
    async fetchEvents (query) {
      const { data, error } = await useFetch(`/api/v1/events?query=${query}`).get().json()

      if (error.value) {
        return {
          data: undefined,
          error: error.value
        }
      }
      this.events = data.value

      return this.events
    },
    async fetchSeminarEvents (seminarType) {
      const { data, error } = await useFetch(`/api/v1/events/seminar/${seminarType}`).get().json()

      if (error.value) {
        return {
          data: undefined,
          error: error.value
        }
      }

      return data.value
    },
    async fetchSeminarTypes () {
      const { data, error } = await useFetch('/api/v1/events/seminars').get().json()

      if (error.value) {
        return {
          data: undefined,
          error: error.value
        }
      }

      return data.value
    }
  }
})
